var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.766,
    height: 54.766,
    viewBox: "0 0 54.766 54.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13276",
    "data-name": "Group 13276",
    transform: "translate(-238.389 -6389.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76562",
    "data-name": "Path 76562",
    d: "M217.482,212.241A5.241,5.241,0,1,1,212.241,207,5.241,5.241,0,0,1,217.482,212.241Zm0,0",
    transform: "translate(53.531 6204.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76563",
    "data-name": "Path 76563",
    d: "M160.633,139.106a5.206,5.206,0,0,0-2.984-2.984,8.7,8.7,0,0,0-2.919-.541c-1.658-.076-2.156-.092-6.354-.092s-4.7.016-6.354.092a8.7,8.7,0,0,0-2.919.542,5.209,5.209,0,0,0-2.985,2.984,8.7,8.7,0,0,0-.541,2.92c-.076,1.658-.092,2.155-.092,6.354s.016,4.7.092,6.354a8.7,8.7,0,0,0,.541,2.919,5.207,5.207,0,0,0,2.984,2.984,8.689,8.689,0,0,0,2.92.542c1.658.076,2.155.091,6.354.091s4.7-.016,6.354-.091a8.689,8.689,0,0,0,2.92-.542,5.207,5.207,0,0,0,2.984-2.984,8.705,8.705,0,0,0,.542-2.919c.076-1.658.092-2.156.092-6.354s-.016-4.7-.092-6.354A8.688,8.688,0,0,0,160.633,139.106Zm-12.257,17.348a8.074,8.074,0,1,1,8.074-8.074A8.074,8.074,0,0,1,148.376,156.453Zm8.393-14.581a1.887,1.887,0,1,1,1.887-1.887A1.887,1.887,0,0,1,156.769,141.873Zm0,0",
    transform: "translate(117.396 6268.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Instagram_",
    "data-name": "Instagram ",
    d: "M27.383,0A27.383,27.383,0,1,0,54.766,27.383,27.386,27.386,0,0,0,27.383,0ZM43.012,33.866a11.536,11.536,0,0,1-.731,3.817,8.04,8.04,0,0,1-4.6,4.6,11.544,11.544,0,0,1-3.816.731c-1.677.076-2.212.095-6.483.095s-4.806-.018-6.483-.095a11.544,11.544,0,0,1-3.816-.731,8.04,8.04,0,0,1-4.6-4.6,11.534,11.534,0,0,1-.731-3.816c-.077-1.677-.1-2.213-.1-6.483s.018-4.806.095-6.483a11.537,11.537,0,0,1,.73-3.817,8.045,8.045,0,0,1,4.6-4.6,11.547,11.547,0,0,1,3.817-.731c1.677-.076,2.212-.095,6.483-.095s4.806.018,6.483.1a11.549,11.549,0,0,1,3.817.73,8.042,8.042,0,0,1,4.6,4.6,11.535,11.535,0,0,1,.731,3.817c.076,1.677.094,2.212.094,6.483S43.089,32.189,43.012,33.866Zm0,0",
    transform: "translate(238.389 6389.685)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.a66cbe1f61367b399570226335c38572.svg";
export { ForwardRef as ReactComponent };